import { Capacitor } from '@capacitor/core';
import { LoggerService } from '@tablesready/frontend-logger';
import { NativeAudio } from '@capacitor-community/native-audio';

const smsConfirmation = 'assets/audio/alert_pop.mp3';
const checkInConfirmation = 'assets/audio/got-it-done.mp3';

export abstract class AudioService {
  private smsElement = new Audio();
  private checkInElement = new Audio();

  constructor(private readonly loggerService: LoggerService) {
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    NativeAudio.preload({
      assetId: 'smsConfirmation',
      assetPath: `public/${smsConfirmation}`,
      audioChannelNum: 1,
      isUrl: false,
    })
      .catch((error) => {
        this.loggerService.warn(`AudioService Error: ${error}`);
      });

    NativeAudio.preload({
      assetId: 'checkInConfirmation',
      assetPath: `public/${checkInConfirmation}`,
      audioChannelNum: 1,
      isUrl: false,
    })
      .catch((error) => {
        this.loggerService.warn(`AudioService Error: ${error}`);
      });
  }

  playSMSConfirmation(): void {
    if (Capacitor.isNativePlatform()) {
      NativeAudio.play({ assetId: 'smsConfirmation' })
        .catch((error) => {
          this.loggerService.warn(`AudioService Error: ${error}`);
        });
      return;
    }

    this.smsElement.src = `./${smsConfirmation}`;
    this.smsElement.load();
    this.smsElement.play()
      .catch((error) => {
        this.loggerService.warn(`AudioService Error: ${error}`);
      });
  }

  playCheckInConfirmation(): void {
    if (Capacitor.isNativePlatform()) {
      NativeAudio.play({ assetId: 'checkInConfirmation' })
        .catch((error) => {
          this.loggerService.warn(`AudioService Error: ${error}`);
        });
      return;
    }

    this.checkInElement.src = `./${checkInConfirmation}`;
    this.checkInElement.load();
    this.checkInElement.play()
      .catch((error) => {
        this.loggerService.warn(`AudioService Error: ${error}`);
      });
  }

  destroy(): void {
    void NativeAudio.unload({ assetId: 'checkInConfirmation' });
    void NativeAudio.unload({ assetId: 'smsConfirmation' });
  }
}
